import { Avatar } from "@/components";
import { cn } from "@/libraries/cn";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { useNavigate } from "@tanstack/react-router";

interface DrawerMoreActionProps extends React.ComponentPropsWithoutRef<"div"> {
	teamId: number;
	onClose: () => void;
}

const DrawerMoreAction: React.FC<DrawerMoreActionProps> = ({
	teamId,
	onClose,
	className,
	...props
}) => {
	const navigate = useNavigate();
	return (
		<div className={cn("relative flex flex-col", className)} {...props}>
			<div className="container py-4 flex flex-row justify-end">
				<IconButton color="primary" onClick={onClose}>
					<CloseRoundedIcon />
				</IconButton>
			</div>
			<Divider />
			<div className="container mb-4">
				<List disablePadding>
					<ListItem disablePadding>
						<ListItemButton
							onClick={() =>
								navigate({
									to: "/dashboard/teams/$id/edit",
									params: { id: teamId },
								})
							}
						>
							<ListItemAvatar>
								<Avatar className="!bg-primary-light">
									<ModeEditOutlineRoundedIcon className="!text-primary" />
								</Avatar>
							</ListItemAvatar>
							<ListItemText primary="Edit Team Name" />
						</ListItemButton>
					</ListItem>
					<Divider component="li" />
					<ListItem disablePadding>
						<ListItemButton
							onClick={() =>
								navigate({
									to: "/dashboard/teams/$id/edit/members",
									params: { id: teamId },
								})
							}
						>
							<ListItemAvatar>
								<Avatar className="!bg-primary-light">
									<PersonAddAltRoundedIcon className="!text-primary" />
								</Avatar>
							</ListItemAvatar>
							<ListItemText primary="Add Team Member" />
						</ListItemButton>
					</ListItem>
				</List>
			</div>
		</div>
	);
};

export default DrawerMoreAction;
